var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "simple-paragraph"
  }, [_c('div', {
    staticClass: "position-relative overflow-hidden",
    class: {
      'read-more': _vm.hideText
    }
  }, [_vm.paragraph.length && _vm.paragraph[0].text ? _c('GlobalRichText', {
    attrs: {
      "payload": _vm.paragraph,
      "cls": !_vm.hasMargin ? 'mb-0' : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.hideText ? _c('button', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'readMore',
      expression: "'readMore'"
    }],
    staticClass: "btn-link btn-link-u pl-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.hideText = false;
      }
    }
  }) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };